import { Component, OnInit } from '@angular/core';
import { ApiService } from './api.service';
import {Storage} from '@ionic/storage-angular'
import { DataServiceService } from './data-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  username: string;
  navigate: any[] = [];
  resData: any;
  AuthToken: any;
  accessModules: any;

  constructor(private api:ApiService, private storage:Storage, private dataservice : DataServiceService,private route:Router) {


    this.api.getToken(999,999).then(async res=>{
      this.resData=res;
      this.AuthToken=this.resData[0]?.token;
      this.api.AuthToken=this.AuthToken;
      this.storage.set('AuthToken',this.AuthToken);
      await this.api.SetAuthorization();
    })
  }

  async ngOnInit(){
    this.storage.create()
    await this.dataservice.dataEvent.subscribe((data) => {

      console.log(data , 'service-data')

      this.accessModules = JSON.parse(data)
      console.log(this.accessModules, 'accessModules-service')
      this.username = this.accessModules.userName
      this.navigate = this.accessModules.routingModules
    })

    if(this.navigate.length < 1){
      this.accessModules = JSON.parse(sessionStorage.getItem('accessModules'))
      if(this.accessModules != null){
        this.username = this.accessModules.userName
        this.navigate = this.accessModules.routingModules
      }
      
    }
    this.dataservice.emitNavChangeEvent(null);
      
  }

  async click(nav){
    
    if(nav.title == 'Logout'){
      sessionStorage.clear()
    }
  }

}
